<template>
  <v-card-title
    dense
    flat
    class="card-title sv-card-title d-flex"
    :height="large ? '64' : '48'"
    :class="{ 'card-title__large': large }"
  >
    <div><slot /></div>
    <v-spacer v-if="closeable" />
    <div v-if="closeable">
      <v-btn id="form-btn-close-dialog" icon @click="$emit('click:close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
  </v-card-title>
</template>

<script>
export default {
  props: {
    large: {
      type: Boolean,
      default: false
    },
    closeable: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style lang="scss">
.sv-card-title {
  border-bottom: none !important;
  .v-toolbar__content {
    .v-toolbar__title {
      font-size: 16px;
    }
  }
}
</style>
